import { EventEmitter } from 'fbemitter';

export const emitter = new EventEmitter();

export const getStoreOrders = () => {
  const ordersString: any = localStorage.getItem('orders');
  let orders: any[] = [];
  if (ordersString) {
    orders = JSON.parse(ordersString);
  }
  return orders;
};

export const setStoreOrders = (orders: any[]) => {
  localStorage.setItem('orders', JSON.stringify(orders));
};

export const branchTypes = [
  {
    code: 'BRANCH',
    name: 'Салбар',
  },
  {
    code: 'BOX',
    name: 'Smart box',
  },
];

export const deliveryTypes = [
  {
    value: 'PICKUP',
    label: 'Салбараас авах',
  },
  {
    value: 'HOMEDELIVERY',
    label: 'Гараас гарт',
  },
];

export const provinceNos = [15];
export const districtNos = [208, 43, 209, 47, 210, 218, 211, 207, 204, 8];
